<div class="fixed bottom-4 right-4 flex flex-col gap-2" style="z-index: 1200">
    @for (toast of toasts; track toast) {
        <div role="alert" [class]="'alert gg-popup min-w-72 max-w-sm ' + levelAlertClass(toast.level)">
            <app-icon [icon]="levelIcon(toast.level)" size="sm"/>
            <div class="flex flex-col gap-0.5">
                <span class="font-semibold text-sm">{{ toast.header }}</span>
                @if (toast.body) {
                    <span class="text-xs opacity-80">{{ toast.body }}</span>
                }
            </div>
            <button type="button" class="btn btn-ghost btn-xs btn-circle shrink-0" (click)="remove(toast)">
                <app-icon icon="app:close" size="sm"/>
            </button>
        </div>
    }
</div>
